export function getNavigatorGeoLocationCoordinates() {
  return new Promise((resolve, reject) => {
    window.navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          lng: position.coords.longitude,
          lat: position.coords.latitude,
        })
      },
      (error) => {
        reject(error)
      }
    )
  })
}

export const swedenGeoPolygonFeature = {
  type: `Feature`,
  properties: {},
  geometry: {
    type: `Polygon`,
    coordinates: [
      [
        [13.758064430533949, 69.63489360829101],
        [11.405819187595228, 67.6473765660352],
        [10.344563123488712, 65.1119566059588],
        [8.026108597097647, 64.19596589506867],
        [4.796192078472245, 63.00404526945087],
        [3.5541958853600875, 61.45435585341946],
        [4.006075563582414, 58.58136859572443],
        [7.06104986999452, 57.55702767286803],
        [10.23027887886974, 58.36347499015449],
        [11.38797354136787, 57.70050969373463],
        [12.385215016684981, 56.57668469239832],
        [12.31917444025072, 56.106673867470704],
        [12.545202579551272, 55.79547068750736],
        [12.881799612262483, 55.16513400827324],
        [15.275135363769294, 54.442180163202835],
        [19.74996043893006, 56.14377415027087],
        [20.490707807164426, 58.136522757466054],
        [20.314433125000164, 60.19234122063716],
        [19.670451047594696, 61.81109104105434],
        [20.569087125676702, 63.06703205632547],
        [22.189345546033138, 64.47939573058761],
        [24.659723741166715, 65.3821135510374],
        [25.1603354240917, 66.31954701166225],
        [25.0288794487129, 67.65336911439601],
        [24.577128969798167, 68.52890269652013],
        [21.55061585078232, 69.45649571458333],
        [19.305562300940522, 70.71900737886185],
        [13.758064430533949, 69.63489360829101],
      ],
    ],
  },
}
